var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'cursor-pointer': _vm.clickable },domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }